module.exports = __webpack_public_path__ + "static/media/4.ae6a6d4f.jpg";